/* cardActionButton-compiled.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./cardActionButton-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

import { N500 } from '@atlaskit/theme/colors';
var variantStyleMap = {
  filled: "_bfhk1pja _irr3tl7t",
  default: "_irr3x5l4"
};
var cardActionButtonStyles = null;
export var CardActionButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$variant;
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    id: "cardActionButton",
    "data-testid": "media-card-primary-action",
    "aria-label": props.label,
    onClick: props.onClick,
    onMouseDown: props.onMouseDown,
    ref: ref,
    className: ax(["_19itglyw _2rkofajl _r06hglyw _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ou6 _4t3i1ou6 _syaz5lkc _d0altlke", variantStyleMap[(_props$variant = props.variant) !== null && _props$variant !== void 0 ? _props$variant : 'default']]),
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      cursor: props.disabled ? 'not-allowed' : 'default',
      "--_1o4qw9f": ix("var(--ds-icon, ".concat(N500, ")"))
    })
  }), props.children);
});